module.exports = __webpack_public_path__ + "static/media/iveco-go-drive.932a5c93.png";